var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-wrapper",class:("" + _vm.btnClass)},[_c('div',{ref:"cheerBtn",staticClass:"btn-cheer",class:{
      animation: _vm.startAnime,
      'infinite-animation': _vm.infiniteLoop,
      'collected-all': _vm.isCollectedAll,
      'is-opened': _vm.openRedpack,
      logined: _vm.isLogin
    },on:{"click":_vm.buttonClicked}},[_vm._v(" "+_vm._s(_vm.btnText)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }